import { has, set, keyBy, getOr } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import {
  paginationState,
  resetPaginationState
} from '../../../../helpers/pagination';
import { createFetchManyHandler } from '../../../../helpers/reducerRoutineCrudHandler';
import { fetchGuestReservations } from '../../sagas/routines';
import {
  clearGuestReservations,
  guestReservationsOnChangePage,
  guestReservationsOnChangeOrder,
  guestReservationsOnChangeLimit
} from '../../actions/reservation';
import { paginationSuccessHandler } from '../../../../helpers/reducerPaginationHandler';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  fetchingError: null,
  pagination: paginationState(),
  order: 'requestTime:desc'
};

const keyProp = 'id';

export const fetchManyHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    all: {
      ...state.all,
      ...keyBy('', getOr([], 'items', response))
    },
    ...(has('pagination', state)
      ? {
          pagination: paginationSuccessHandler(
            state.pagination,
            response,
            keyProp
          )
        }
      : {})
  }),
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const clearHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    all: {},
    fetched: false,
    pagination: resetPaginationState(state.pagination)
  })
});

const updateCurrentPageHandler = action => ({
  [action.toString()]: (state, { payload: page }) =>
    set('pagination.currentPage', page, state)
});

const updateOnChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

const updateOnChangeLimitHandler = action => ({
  [action.toString()]: (state, { payload: limit }) =>
    set('pagination.limit', limit, state)
});

export default createReducer(initialState, {
  ...createFetchManyHandler(fetchGuestReservations, keyProp),
  ...clearHandler(clearGuestReservations),
  ...updateCurrentPageHandler(guestReservationsOnChangePage),
  ...updateOnChangeLimitHandler(guestReservationsOnChangeLimit),
  ...updateOnChangeOrderHandler(guestReservationsOnChangeOrder)
});
